import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "-3.5 -3.5 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-3.5 -3.5 30 30\" id=\"icon-edit\">\r\n\t<path d=\"M16 3.39L5.96 13.43 0 16l2.57-5.96L12.61 0zM1.21 14.79l4.33-2.05-2.28-2.28z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol